import { jsx as _jsx } from "react/jsx-runtime";
import { Breadcrumbs, Typography } from '@mui/material';
import { observer } from 'mobx-react-lite';
import { useTranslation } from 'react-i18next';
import { Link as RRLink } from 'react-router-dom';
import { ROUTES } from '~/routes/routes';
export var Breadcrumb;
(function (Breadcrumb) {
    Breadcrumb.Nav = observer(({ children }) => {
        return (_jsx(Breadcrumbs, { maxItems: 2, separator: "\u203A", children: children }));
    });
    Breadcrumb.Link = ({ children, to, state }) => {
        return (_jsx(RRLink, { to: to, state: state, children: _jsx(Typography, { variant: "body2", color: "inherit", children: children }) }));
    };
    Breadcrumb.Funds = () => {
        const { t } = useTranslation();
        return _jsx(Breadcrumb.Link, { to: ROUTES.FUNDS.path, children: t('DRAWER_ITEM_FUNDS') });
    };
    Breadcrumb.Recent = () => {
        const { t } = useTranslation();
        return _jsx(Breadcrumb.Link, { to: ROUTES.FUNDS.path, children: t('BOTTOM_NAV_FOUNDS') });
    };
    Breadcrumb.Media = () => {
        const { t } = useTranslation();
        return (_jsx(Breadcrumb.Link, { to: ROUTES.FUNDS.MEDIA.path, state: { categories: null }, children: t('BOTTOM_NAV_MEDIA') }));
    };
    Breadcrumb.Books = () => {
        const { t } = useTranslation();
        return _jsx(Breadcrumb.Link, { to: ROUTES.FUNDS.BOOKS.path, children: t('BOTTOM_NAV_BOOKS') });
    };
    Breadcrumb.Contacts = () => {
        const { t } = useTranslation();
        return _jsx(Breadcrumb.Link, { to: ROUTES.FUNDS.CONTACTS.path, children: t('BOTTOM_NAV_CONTACTS') });
    };
    Breadcrumb.SubCategory = ({ breadCrumbName, breadCrumbId, index }) => {
        return (_jsx(Breadcrumb.Link, { to: ROUTES.FUNDS.MEDIA.SUB_CATEGORY.path, state: { categories: { categoryId: breadCrumbId, categoryIndex: (index || 0) + 1 } }, children: breadCrumbName }));
    };
})(Breadcrumb || (Breadcrumb = {}));
